var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: "generator-features-modal", size: "modal-md" } },
    [
      _c(
        "ModalHeader",
        {
          style: { padding: "4px 12px" },
          attrs: {
            title: _vm.$t("xWhatAreTheFeatures"),
            icon: "far fa-circle-info colorOrange mr-1"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button", "data-test-hook": "CloseModalBtn" },
                on: {
                  click: function($event) {
                    return _vm.closeGeneratorFeaturesModal()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", { staticClass: "features" }, [
          _c("div", { staticClass: "basic" }, [
            _c(
              "p",
              {
                staticClass: "mb-1",
                attrs: {
                  "data-test-hook":
                    "generator-features-modal-generator-basic-features-text"
                }
              },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("xFeaturesIncludedInPlan")) +
                      _vm._s(_vm.$t("xBasic"))
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "far fa-fw fa-clipboard-list" }),
              _c("div", [
                _c(
                  "p",
                  {
                    staticClass: "basic-features",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-basic-features-text"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "xFeaturesIncludedWiFiAnnuallySubscriptionFeature1"
                          )
                        ) +
                        " "
                    )
                  ]
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "premium" }, [
            _c(
              "p",
              {
                staticClass: "mb-1",
                attrs: {
                  "data-test-hook":
                    "generator-features-modal-generator-premium-features-text"
                }
              },
              [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("xAdditionalFeatuesInPremium")))
                ])
              ]
            ),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "far fa-fw fa-bell" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-real-time-alerts-header-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xRealTimeAlerts")) + " ")]
                ),
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-supporting-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-real-time-alerts-supporting-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xRealTimeAlertsDesc")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "far fa-fw fa-calendar" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-exercise-settings-header-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xExerciseSettings")) + " ")]
                ),
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-supporting-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-exercise-settings-supporting-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xExerciseSettingsDesc")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "far fa-fw fa-arrows-spin" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-exercise-on-demand-header-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xExerciseOnDemand")) + " ")]
                ),
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-supporting-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-exercise-on-demand-supporting-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xExerciseOnDemandDesc")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "far fa-fw fa-warning" }),
              _c("div", [
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-dismiss-warnings-header-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xDismissWarnings")) + " ")]
                ),
                _c(
                  "p",
                  {
                    staticClass: "premium-feature-supporting-text",
                    attrs: {
                      "data-test-hook":
                        "generator-features-modal-generator-premium-dismiss-warnings-supporting-text"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xDismissWarningsDesc")) + " ")]
                )
              ])
            ])
          ]),
          _c(
            "p",
            {
              staticClass: "premium-feature-supporting-text",
              attrs: {
                "data-test-hook":
                  "generator-features-modal-standard-rates-apply-text"
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s("*" + _vm.$t("xStandardDataRatesPlansAutoRenew")) +
                  " "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }